import { api } from "@ts/core/api";
import { Cookie } from "@ts/core/Cookie";
import { Elements } from "@ts/core/Elements";
import { instruction } from "@ts/core/Instruction";
import { simpleForm } from "@ts/core/SimpleForm";
import { uploadFile } from "@ts/core/uploadFile";
import { yesNo } from "@ts/core/YesNo";
import { MediaData } from "@ts/data/MediaData";
import { VideoSection } from "@ts/sections/VideoSection";

export function createVideoSection(): Promise<boolean> {

    return new Promise((resolve) => {
        instruction('Välj den videofil du vill ladda upp').then((result) => {
            if (!result) resolve(false);

            const data = new Object as MediaData;
            data.mediaid = 0;
            data.mediafile = '';
            data.comment = '';

            uploadFile('video', Cookie.pagename)
                .then(async (file: string | false) => {
                    if (!file) return resolve(false);

                    data.mediafile = file;
                    simpleForm('Video', 4, 'Lägg till kommentar', '',
                        'Skiv din kommentar här eller lämna tomt om du inte vill lägga till en')
                        .then((text: string) => {
                            data.comment = text;
                        });

                    yesNo('Skugga', 'Vill du att videofilen ska ha skuggning?')
                        .then((result: boolean) => {
                            data.shadow = result;
                        });

                    const resp = await api<{ data: MediaData }>('createSection', {
                        pos: Elements.contentContainer.childElementCount,
                        pagename: Cookie.pagename,
                        data: data,
                        type: 'video'
                    });
                    if (resp) {
                        const section = new VideoSection(resp.data);
                        section.render();
                        section.enableEdit = true;
                        section.beginEdit();
                        resolve(true);
                    }

                });
            resolve(false);
        });

    });
}